// extracted by mini-css-extract-plugin
export default {"prevalence":"Dzhf5jW3fv5ygryUHpBG","close-icon":"OEFmFuJKJt2tyPgwRZOA","select":"T4CQop53HsqbDsWDq5V5"};